export const data = function() {
  return {
    isDebug: true,
    loading: false,
    violationID: 0,
    violation: null,
    tabs: [
      { name: 'violationDetails', label: 'Details' },
      { name: 'violationHistory', label: 'History' },
      { name: 'violationConversations', label: 'Conversations' }
    ],
    styles: {
      mainContainer: {
        minHeight: '1000px'
      }
    },
    transitionName: 'slide-down',
    showUploadModal: false
  }
}
